import classes from './AccountItem.module.scss';
import { Flex, Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Account, AccStatus } from 'entities/account/model/types';

type Props = {
  account: Account;
  onAccountClick: (accountId: number) => void;
  secured?: boolean;
}

const AccountItem: React.FC<Props> = ({ account, onAccountClick, secured }) => {
  const balanceFixed = account.available ? account.available.toFixed(2) : '0.00';
  const balanceString = balanceFixed.replace('.', ',');
  const [wholePart, fractionalPart] = balanceString.split(',');

  return (
    <div
      className={classes.accountContainer}
      key={account.id}
      onClick={() => onAccountClick(account.id)}
    >
      <Flex gap={4} align='center'>
        <Typography.Text className={classes.title} ellipsis>
          {account.title}
        </Typography.Text>
        {account.status !== AccStatus.Closed ? (
          <div
            style={{
              borderRadius: '50%',
              backgroundColor: 'rgb(185, 227, 181)',
              width: 16,
              height: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CheckOutlined style={{ fontSize: 8 }} />
          </div>
        ) : (
          <div
            style={{
              borderRadius: '50%',
              backgroundColor: 'rgb(246,176,176)',
              width: 16,
              height: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CloseOutlined style={{ fontSize: 8 }} />
          </div>
        )}
      </Flex>
      <Typography.Text
        className={classes.balance}
        id={secured ? 'plan-balance-hidden' : 'plan-balance-shown'}
      >
        {secured ? '*' : wholePart},
        <Typography.Text className={classes.fractionalPart}>
          {secured ? '**' : fractionalPart} €
        </Typography.Text>
      </Typography.Text>
    </div>
  );
};

export default AccountItem;
